import React from 'react';
import { Toolbar, Box, Typography, Button, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const TextToolbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuItems = [
    { label: 'Post Splitter', path: '/PostSplitter' },
    { label: 'Sentiment Analyzer', path: '/SentimentAnalyzer' },
    { label: 'AI Text Detector', path: '/AITextAnalyzer' },
    { label: 'Readability Checker', path: '/ReadabilityAnalyzer' },
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <React.Fragment>
      <Toolbar sx={{ justifyContent: 'space-between', px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Link to="/" style={{ textDecoration: 'none' }} aria-label="Home">
            <img src="/logo500.png" alt="Text Simpler Logo" style={{ height: '50px', cursor: 'pointer' }} loading="lazy" />
          </Link>

          <Box>
            <Typography variant="h6" component="div">
              Text Simpler
            </Typography>
            <Typography
              variant="body2"
              component="div"
              sx={{ fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.7)' }}
            >
              Text tools to split, enhance, analyze, and simplify.
            </Typography>
          </Box>
         
        </Box>
        {isMobile ? (
          <IconButton onClick={handleDrawerToggle} sx={{ color: 'white' }} aria-label="Open navigation menu">
            <MenuIcon />
          </IconButton>

        ) : (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {menuItems.map((menu) => (
              <Button
                key={menu.label}
                component={NavLink}
                to={menu.path}
                color="inherit"
                sx={{
                  color: 'rgba(255, 255, 255, 0.7)', // Default color
                  textTransform: 'none', // Prevents uppercase
                  '&:hover': {
                    color: '#C62368', // Hover color
                  },
                  '&.active': {
                    color: '#FF4081', // Selected (active) color
                  },
                }}
                aria-label={`Navigate to ${menu.label}`}
              >
                {menu.label}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>

      {/* Drawer for Mobile Navigation */}
      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        <Box
          sx={{ width: 250, bgcolor: '#101a30', height: '100%' }}
          role="presentation"
          onClick={handleDrawerToggle}
          onKeyDown={handleDrawerToggle}
        >
          <List>
            {menuItems.map((menu) => (
              <ListItem button key={menu.label} component={NavLink} to={menu.path} aria-label={`Navigate to ${menu.label}`}>
                <ListItemText
                  primary={menu.label}
                  primaryTypographyProps={{
                    color: 'white',
                    sx: { '&.MuiTypography-root': { fontWeight: 'bold' } },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </React.Fragment>
  );
};

export default TextToolbar;
